export default __webpack_public_path__ + "static/media/robocom2.adf006aa.jpg";